import BDOLogo from "../../../../../../../../Assets/Design/BDOLogo.png";
import GCash_Logo from "../../../../../../../../Assets/Design/GCash_Logo.png";
import BPILogo from "../../../../../../../../Assets/Design/BPILogo.png";
import "./Payment.scss";
import "./PaymentMobile.scss";
import gcashQR from "../../../../../../../../Assets/Design/gcashQR.jpg";
import bpiQR from "../../../../../../../../Assets/Design/bpiQR.jpg";
import bdoQR from "../../../../../../../../Assets/Design/bdoQR.jpg";
import { useState } from "react";
import { useAppContext } from "../../../../../../../../Components/AppProvider";

export default function Payment({
  setProgress,
  progress,
  setPaymentMethod,
  paymentMethod,
  paymentType,
  amountToPay,
  hasPartial,
}) {
  return (
    <div className="payment-modal-container">
      <h2>PAYMENT</h2>
      <span className="subject">
        Please choose payment method and scan the QR code
      </span>

      <span className="price-to-pay">
        {hasPartial
          ? "TOTAL BALANCE AMOUNT: PHP "
          : paymentType === "full"
          ? `TOTAL FULL PAYMENT AMOUNT: PHP `
          : `TOTAL DOWNPAYMENT AMOUNT: PHP `}

        {amountToPay}
      </span>
      <div className="payment-method-container">
        <div className="payment-card-wrapper">
          {/* GCASH */}
          <button
            className={`payment-card Gcash ${
              paymentMethod === "gcash" ? "active" : ""
            }`}
            onClick={() => setPaymentMethod("gcash")}
          >
            <img src={GCash_Logo} alt="GCash" />
          </button>
          {/* BPI */}
          <button
            className={`payment-card BPI ${
              paymentMethod === "bpi" ? "active" : ""
            }`}
            onClick={() => setPaymentMethod("bpi")}
          >
            <img src={BPILogo} alt="BPI" />
          </button>
          {/* BDO */}
          <button
            className={`payment-card BDO ${
              paymentMethod === "bdo" ? "active" : ""
            }`}
            onClick={() => setPaymentMethod("bdo")}
          >
            <img src={BDOLogo} alt="BDO" />
          </button>
        </div>

        {/* QR Preview Example */}
        <div className={`qr-preview ${paymentMethod}`}>
          <div
            className="qr-code-wrapper"
            style={
              paymentMethod === "gcash"
                ? { backgroundColor: "#005ce5" }
                : paymentMethod === "bpi"
                ? { backgroundColor: "#d6474b" }
                : paymentMethod === "bdo"
                ? { backgroundColor: "#ffffff" }
                : ""
            }
          >
            {paymentMethod === "gcash" && (
              <>
                <img src={gcashQR} />
              </>
            )}
            {paymentMethod === "bpi" && (
              <>
                <img src={bpiQR} />
              </>
            )}
            {paymentMethod === "bdo" && (
              <>
                <img src={bdoQR} />
              </>
            )}
          </div>
        </div>
      </div>
      <div className="action-button">
        <button
          className="cancel"
          onClick={() => {
            setProgress(progress - 1);
          }}
        >
          BACK
        </button>
        <button
          className="proceed"
          onClick={() => {
            setProgress(progress + 1);
          }}
        >
          PROCEED
        </button>
      </div>
    </div>
  );
}
